<template>
    <div class="checkbox-wrapper" :class="{ disabled: disabled }">
        <input
                ref="checkbox"

                class="k-checkbox custom-kendo-checkbox-for"
                type="checkbox"
                v-bind:checked="checked"
        />

        <label
                class="k-checkbox-label"
                @click.self.prevent="clicked"
        >
            {{label}}
        </label>
    </div>
</template>

<script>
    import {guid} from "../../../../Util/guid";
    
    import {bootstrapWarningGrowl} from "@core/Util/growler";

    //IE is trash, thus we need to explicitly listen to our label for click events
    //instead of just input on our checkbox
    
    export default {
        name: "scenario-list-item-checkbox",
        created(){
            const vm = this;
            vm.controlId = `CHK_${guid()}`;

            //Pre-checked = active = readonly
            vm.checked = vm.value;
            vm.readonly = vm.value;
        },
        methods: {
            clicked(){
                const vm = this;
                const el = vm.$refs.checkbox;
                
                //Reset back to previous displayed state
                if(vm.readonly || vm.disabled) {
                    el.checked = this.checked;
                    
                    if(vm.disabled) {
                        bootstrapWarningGrowl(this.disabledClickWarningMessage);
                    }
                    
                    return;
                }
                
                //Toggle checked
                vm.checked = !vm.checked;
                el.checked = vm.checked;
                
                vm.$emit('input', vm.checked);
            }
        },
        data: () => ({
            controlId: '',
            checked: false,
            readonly: false
        }),
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
                required: true
            },
            
            //Not really disabled as events are still emitted, but it works
            disabled: {
                type: Boolean,
                required: false
            },
            disabledClickWarningMessage: {
                type: String,
                required: false
            }
        }
    }
</script>

<style scoped src="../../Style/scenario-list-item-checkbox.scss" lang="scss">
</style>
